import { render, staticRenderFns } from "./EditEmployee.vue?vue&type=template&id=46640edc&"
import script from "./EditEmployee.vue?vue&type=script&lang=ts&"
export * from "./EditEmployee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports